<script lang="ts" setup>
import { createReusableTemplate, useMediaQuery } from '@vueuse/core'
import { Button } from '@/components/ui/button'
import { Drawer, DrawerContent, DrawerTrigger } from '@/components/ui/drawer'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { Input } from '@/components/ui/input'

const props = defineProps({
    label: {
        type: String,
        required: true
    },
    icon: {
        type: String,
    },
    min: {
        type: Number,
        default: 1
    },
    max: {
        type: Number,
        default: 10000
    },
    btn_class: {
        type: String,
        default: null
    },
})

const minValue = defineModel<number>('minValue')
const maxValue = defineModel<number>('maxValue')

const [UseTemplate, RangeFilter] = createReusableTemplate()
const isDesktop = useMediaQuery('(min-width: 768px)')
const isOpen = ref(false)
const model = ref<number[]>([])
const step = ref<number>(5)

watch(model, (newVal) => {
    if (newVal[0] < props.min) model.value.splice(0, 1, props.min);
    if (newVal[1] > props.max) model.value.splice(1, 1, props.max);
}, {
    deep: true
})

onMounted(() => {
    if(minValue.value && maxValue.value){
        model.value = [minValue.value, maxValue.value]
    } else {
        model.value = [props.min, props.max]
    }
    const computed_step = Math.round((props.max - props.min) / 100)
    step.value = computed_step > 5 ? computed_step : 5
})

function applyFilter(){
    if(minValue.value != model.value[0]){
        minValue.value = model.value[0]
    }
    if(maxValue.value != model.value[1]){
        maxValue.value = model.value[1]
    }
}

</script>

<template>
    <div>
        <p class="text-2xl font-bold mb-2">{{label}}</p>
        <div class="bg-white rounded border-1">
            <div class="fields_range flex justify-between gap-4">
                <div class="range_field_input__wrap relative">
                    <Input type="number" :min="min" :max="model[1] - 5" :step="step" v-model="minValue"
                             :placeholder="$t('Price up')" class="range_field_input bg-stroke" />
                    <span class="absolute right-3 rtl:right-auto rtl:left-3 top-1/2 -translate-y-1/2 text-gray-300 text-sm font-medium"> AED</span>
                </div>

                <div class="range_field_input__wrap relative">
                    <Input type="number" :min="model[0] + 5" :max="max" :step="step" v-model="maxValue"
                             :placeholder="$t('Price to')" class="range_field_input bg-stroke" />
                    <span class="absolute right-3 rtl:right-auto rtl:left-3 top-1/2 -translate-y-1/2 text-gray-300 text-sm font-medium"> AED</span>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
input.range_field_input[type=number]::-webkit-outer-spin-button,
input.range_field_input[type=number]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input.range_field_input[type=number] {
    -moz-appearance: textfield;
    appearance: textfield;
}
</style>